import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { useNavigate, useParams } from "react-router-dom";
import "./Spinner.css";
import "./Loader.css";
import "./Stepper.css"; // Custom CSS for the stepper
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { Modal, Button, Pagination } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { FaRegUserCircle } from "react-icons/fa";

function BookDoctorAppointment() {
   const { userid } = useParams();
  const [doctors, setDoctors] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [appointmentDate, setAppointmentDate] = useState("");
  const [step, setStep] = useState(1);
  const [loader, setLoader] = useState(true);
  const [showWarningModal, setShowWarningModal] = useState(false); // State for warning modal
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [paymentRequiredResponse, setPaymentRequiredResponse] = useState(true);
  const [employee, setEmployee] = useState(null);
  const navigate = useNavigate();
  const userRole = JSON.parse(localStorage.getItem("data")).role;
  const token = JSON.parse(localStorage.getItem("data")).token;

  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);  
    } else {
      getData(currentPage);   
  }
  }, [searchTerm]); 

  const searchData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const searchUrl = `/api/doctordetails/searchDoctorsForAppointment`;
                 const requestData = {
                   searchTerm,
                   companyId:employee.companyId
                 };
      const response = await axios.post(searchUrl, requestData,{
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` }, // Authorization header
      });

      setDoctors(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {  

        const empRes = await axios.get(`/api/employeedetails/userid=${userid}`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setEmployee(empRes.data);    
        
        const requestData = {
            companyId:empRes.data.companyId,
          };
      const trans = await axios.post(`/api/doctordetails/getAllDoctorsForAppointment`, requestData, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setDoctors(trans.data.content);
      setCurrentPage(trans.data.number);
      setTotalPages(trans.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };

  const handleBookAppointment = async () => {
    if (!appointmentDate) {
      toast.warn("Please select a date");
      return;
    }
   
     // Perform date validation here
   const selectedDate = new Date(appointmentDate);
   const currentDate = new Date();
   // Set oneDayFromNow to start at midnight (00:00:00)
   const oneDayFromNow = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + 1);
   
   if (userRole !== 'ROLE_SUPER' && userRole !== 'ROLE_ADMIN') {
       if (selectedDate < oneDayFromNow || selectedDate.getDay() === 0) {
           toast.warn("Please select a weekday other than Sunday and ensure the date is at least 1 day from today.");
           return;
       }
   }
   

   if (selectedDate.getDay() === 0) {
         toast.warn("Please select a weekday other than Sunday.");
         return;
       }

    setShowWarningModal(true); // Show the warning modal
    
  };


  const confirmBookAppointment = async () => {

    try {
      setLoader(true);
      await axios.post(
        "/api/doctorappointment/create",
        {
            employeeId: employee.id,
            doctorId: selectedDoctor.id,
            appointmentDate:appointmentDate,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      toast.success("Doctor Appointment Booked successfully");
      if(userRole==='ROLE_EMPLOYEE'){
      navigate('/users/employee-appointments');
      }else{
        navigate(`/users/employee-profile/${userid}`);
      }
    } catch (error) {
      setLoader(false);
      handleError(error);
    } finally {
      setShowConfirmationModal(false); // Close the modal
    }

  };


  // const handleUseMyLocation = () => {
  //   if (navigator.geolocation) {
  //     navigator.geolocation.getCurrentPosition(position => {
  //       const { latitude, longitude } = position.coords;
  //       const filtered = labs.filter(lab => {
  //         const distance = calculateDistance(latitude, longitude, lab.latitude, lab.longitude);
  //         console.log(`Distance to ${lab.labname}: ${distance.toFixed(2)} km`);
  //         return distance <= 10; // Filter labs within 10 km
  //       });
  //       setFilteredLabs(filtered);
  //     }, error => {
  //       console.error("Error getting location:", error);
  //       toast.error("Unable to retrieve your location.");
  //     });
  //   } else {
  //     toast.error("Geolocation is not supported by this browser.");
  //   }
  // };
  
  // const calculateDistance = (lat1, lon1, lat2, lon2) => {
  //   const R = 6371; // Radius of the Earth in km
  //   const dLat = degreesToRadians(lat2 - lat1);
  //   const dLon = degreesToRadians(lon2 - lon1);
  //   const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
  //             Math.cos(degreesToRadians(lat1)) * Math.cos(degreesToRadians(lat2)) *
  //             Math.sin(dLon / 2) * Math.sin(dLon / 2);
  //   const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  //   return R * c; // Distance in km
  // };

  // const degreesToRadians = (degrees) => {
  //   return degrees * (Math.PI / 180);
  // };

  const handleUseMyLocation = async (pageNumber = 0) => {
    setLoader(true);
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(async (position) => {
        const { latitude, longitude } = position.coords;  
        try {
          const response = await axios.get(`/api/doctordetails/nearByLocation`, {
            params: { 
              latitude, 
              longitude, 
              radius: 10, 
              empUserid:userid,
              page: pageNumber
            },
            headers: { Authorization: `Bearer ${token}` }
          });
  
          setDoctors(response.data.content); // Only set the labs, not the entire page object
          setCurrentPage(response.data.number);
          setTotalPages(response.data.totalPages);
          setLoader(false);
        } catch (error) {
          setLoader(false);
          handleError(error);
        }
  
      }, error => {
        handleError(error);
        setLoader(false);
      });
    } else {
      setLoader(false);
      toast.error("Geolocation is not supported by this browser.");
    }
  };
  

  const renderStepContent = (step) => {
    switch (step) {
      case 1:
        return (
          <div className="row">
            <div className="col-md-12">
              <div className="card card-raised">
                <div className="card-body">
                <div className="card-title form-group d-flex align-items-center justify-content-between">
  <span>Choose Doctor</span>
  <div className="d-flex align-items-center">
    <div className="form-group position-relative" style={{ width: '300px', marginRight: '10px' }}>
      <input
        type="search"
        className="form-control"
        placeholder="Search by Doctor name, city, pincode"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ paddingLeft: "2rem", width: "100%" }}
      />
      <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
        <FontAwesomeIcon icon={faSearch} />
      </span>
    </div>
    {/* <Button variant="outline-primary" onClick={() => handleUseMyLocation(0)}>
      <FontAwesomeIcon icon={faMapMarkerAlt} /> Use My Location
    </Button> */}
  </div>
</div>


                  <div className="row mt-5">
                  {doctors.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (doctors.map((doctor) => (
                      <div className="col-md-4 mb-4" key={doctor.id}>
                        <div
                          className={`card ${selectedDoctor && selectedDoctor.id === doctor.id ? 'border-primary' : ''}`}
                          onClick={() => setSelectedDoctor(doctor)}
                          style={{ cursor: "pointer" }}
                        >
                            <div className="card-title text-center mt-2">
                                 {doctor.doctorProfileImage?.image  ? (
                                   <img 
                                     src={`${doctor.doctorProfileImage?.imageMeta},${doctor.doctorProfileImage?.image}`} 
                                     alt="User Profile" 
                                     style={{ width: '100px', height: '100px', borderRadius: '50%' }} 
                                   />
                                 ) : (
                                    <FaRegUserCircle size={100} color="#ccc"/>
                                 )}
                               </div>
                                           
                          <div className="card-body">
                            <h5 className="card-title text-center mb-2">{doctor.doctorName}</h5>
                            <p className="card-text">Contact Number: {doctor.phoneNumber}</p>
                            <p className="card-text">Email: {doctor.email}</p>
                            <p className="card-text">Address: {doctor.address}</p>
                            <p className="card-text">{doctor.city}, {doctor.pincode}, {doctor.state}</p>
                          </div>
                        </div>
                      </div>
                    )))}
                  </div>
                  <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>
            <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <button className="btn btn-primary" onClick={() => setStep(2)} disabled={!selectedDoctor}>Next</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="row">
            <div className="col-6 mx-xl-auto ">
              <div className="card card-raised">
                <div className="card-body">
                  <div className="card-title mb-2">Book Doctor Appointment</div>
                  {selectedDoctor && (
                    <div>
                      <p>Selected Doctor: {selectedDoctor.doctorName}({selectedDoctor.phoneNumber})</p>
                    
                      <div className="row mt-3">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="date">Select Date <span style={{color:"red"}}>* </span></label>
                      <input
                        type="date"
                        id="appointmentDate"
                        className="form-control"
                        value={appointmentDate}
                        onChange={(e) => setAppointmentDate(e.target.value)}
                        min={new Date().toISOString().split("T")[0]}
                        required
                      />
                    </div>
                    
                                     </div>
                  </div>
                  )}
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-between">
                      <button className="btn btn-secondary" onClick={() => setStep(1)}>Back</button>
                      <button className="btn btn-primary"  
                     onClick={handleBookAppointment}>Book Appointment</button>
                    </div>
                    </div>
                    </div>
                    </div>
            </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div>
        <AdminDashboard />
      </div>
      <div className="col-12 mx-xl-auto ps-xl-10" style={{ marginTop: "10%" }}>
        <div className="stepper-wrapper">
          <div className={`stepper-item ${step === 1 ? 'active' : ''}`}>
            <div className="step-counter">1</div>
            <div className="step-name">Select Doctor</div>
          </div>
          <div className={`stepper-item ${step === 2 ? 'active' : ''}`}>
            <div className="step-counter">2</div>
            <div className="step-name">Book Appointment</div>
          </div>
        </div>
        {renderStepContent(step)}
        {loader && <div className="loading"></div>}
      </div>

      {/* Modal for 10-hour fasting warning */}
      <Modal show={showWarningModal} onHide={() => setShowWarningModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Warning</Modal.Title>
        </Modal.Header>
        <Modal.Body>
        Please ensure that the employee is fasting for at least 10 hours before taking the test.
        
      {paymentRequiredResponse.requireEmpPayment===true &&(
        <>
        <br/> <br/>
        <p style={{ color: 'red' }}>
        Please note, in case of appointment cancellation, the charges of platform fee will not be refunded.
        </p>
        </>
      )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" className="me-3" onClick={() => setShowWarningModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={confirmBookAppointment}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

export default BookDoctorAppointment;
